<div class="green-theme">
    <div class="container">
        <mat-table #table matSort multiTemplateDataRows [dataSource]="dataSource" background="#15151c"
            class="partner-group-table">

            <ng-container matColumnDef="members" class="group-name-container">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Group <app-sort-arrows-icon
                        [direction]="getSortDirection('members')" class="sort-arrows"></app-sort-arrows-icon>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">

                    <div [matTooltip]="getGroupDisplayName(element)" class="group-name">
                        <div class="group-name">
                            {{ element.group.name }}
                            <!-- <div *ngFor="let member of element.members; let i = index;">
                                <div *ngIf="member.partner.id != mibeId">
                                    <span>{{ member.partner.name }}</span>
                                    <span *ngIf="i < element.members.length - 1">
                                        <app-plus-icon [height]="'10'" [width]="'8'" [stroke]="'#50e3c2'"
                                            style="padding-left: 2px; padding-right: 2px;"></app-plus-icon>
                                    </span>
                                </div>
                            </div> -->
                        </div>
                    </div>

                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="totalAllocationPercentage" class="allocation-percentage-container">
                <mat-header-cell *matHeaderCellDef mat-sort-header (click)="sortByAllocation()"> Allocation
                    <app-sort-arrows-icon [direction]="getSortDirection('totalAllocationPercentage')"
                        class="sort-arrows"></app-sort-arrows-icon></mat-header-cell>
                <mat-cell *matCellDef="let element" class="allocation-percentage-col">
                    <span class="allocation-percent-container">
                        <span class="allocation-percent">
                            {{getTotalAllocationPercentage(element)}}%
                        </span>
                    </span>
                    <span class="dilute-checkbox-container">
                        <span class="dilute-checkbox">
                            <mat-checkbox class="dark-theme"
                                [ngClass]="{'selected-checkbox' : element.exportDilutedValue, 'unselected-checkbox' : !element.exportDilutedValue}"
                                [(ngModel)]="element.exportDilutedValue">Export Diluted Values
                            </mat-checkbox>
                        </span>
                    </span>
                </mat-cell>
            </ng-container>


            <ng-container matColumnDef="action" class="action-icons-container">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <div class="action-icons">
                        <app-plus-icon (click)="addPartnerToGroup(element.group)"></app-plus-icon>

                        <app-drop-down-arrow *ngIf="!element.expandDetails" [stroke]="'#50e3c2'"
                            (click)="toggleDetails(element)"></app-drop-down-arrow>
                        <app-drop-down-arrow *ngIf="element.expandDetails" [pointUp]="true" [stroke]="'#50e3c2'"
                            (click)="toggleDetails(element)"></app-drop-down-arrow>
                    </div>
                </mat-cell>
            </ng-container>

            <!-- Expanded details row -->

            <ng-container matColumnDef="expandedDetails">

                <mat-cell [attr.colspan]="displayedColumns.length + 1" *matCellDef="let element">

                    <div class="partner-table" cdkDropList (cdkDropListDropped)="onDrop($event, element.group)">
                        <div *ngFor="let member of element.members">
                            <div *ngIf="!member.postDilutionParentId" class="partner-row" [cdkDrag]>

                                <!-- MEMBERS WHO ARE NOT POST DILUTORS START -->

                                <div class="parent-member">
                                    <span class="partner-name">{{member.partner.name}}</span>
                                    <mat-form-field appearance="fill" class="allocation-field">
                                        <input class="member-percentage-input" matInput
                                            [ngModel]="member.allocationPercentage" type="number"
                                            (ngModelChange)="onPercentageChange($event, element, member)">
                                        <span class="percentage-symbol">%</span>
                                    </mat-form-field>

                                    <mat-button class="add-post-dilutor-btn" (click)="addPostDilutor(member, element)">
                                        Add Post Dilutor
                                    </mat-button>
                                    <!-- <mat-checkbox class="dark-theme post-dilution-checkbox" [(ngModel)]="member.postDilution"
                                (ngModelChange)="updatePartnerGroupMember(member)"
                                [ngStyle]="{'visibility': member.partner.name === 'Mibe Music' ? 'hidden' : 'visible'}">
                                Post Dilution
                            </mat-checkbox> -->
                                    <div class="action-icons">
                                        <app-drop-down-arrow
                                            *ngIf="!member.expandDetails && member.postDilutionChildren.length > 0"
                                            [stroke]="'#50e3c2'" (click)="toggleDetails(member)"></app-drop-down-arrow>
                                        <app-drop-down-arrow
                                            *ngIf="member.expandDetails && member.postDilutionChildren.length > 0"
                                            [pointUp]="true" [stroke]="'#50e3c2'"
                                            (click)="toggleDetails(member)"></app-drop-down-arrow>
                                        <app-close-x-icon
                                            [ngStyle]="{'visibility': member.partner.name === 'Mibe Music' ? 'hidden' : 'visible'}"
                                            [stroke]="'#FFFFFF'"
                                            (click)="removeMemberFromGroup(member, element)"></app-close-x-icon>
                                        <app-grab-icon
                                            [ngStyle]="{'visibility': member.partner.name === 'Mibe Music' ? 'hidden' : 'visible'}"
                                            cdkDragHandle [stroke]="'#FFFFFF'"></app-grab-icon>
                                    </div>
                                </div>

                                <!-- MEMBERS WHO ARE NOT POST DILUTORS END -->

                                <!-- POST DILUTORS START -->

                                <div *ngIf="member.postDilutionChildren.length > 0 && member.expandDetails">
                                    <div *ngFor="let postDilutor of member.postDilutionChildren">
                                        <div *ngIf="postDilutor.postDilutionParentId" class="partner-row" [cdkDrag]>
                                            <div class="child-member">
                                                <span class="partner-name">{{postDilutor.partner.name}}</span>
                                                <mat-form-field appearance="fill" class="allocation-field">
                                                    <input class="member-percentage-input" matInput
                                                        [ngModel]="postDilutor.allocationPercentage" type="number"
                                                        (ngModelChange)="onPercentageChange($event, element, postDilutor)"
                                                        (mousedown)="onPercentageMousedown($event)">
                                                    <span class="percentage-symbol">%</span>
                                                </mat-form-field>
                                                <!-- <mat-button class="add-post-dilutor-btn" (click)="addPostDilutor(member, element)">
                                                    Add Post Dilutor
                                                </mat-button> -->
                                                <mat-checkbox class="post-dilution-checkbox"
                                                    [(ngModel)]="postDilutor.postDilution"
                                                    (ngModelChange)="updatePartnerGroupMember(postDilutor)"
                                                    [ngStyle]="{'visibility': postDilutor.partner.name === 'Mibe Music' ? 'hidden' : 'visible'}"
                                                    [checked]="postDilutor.postDilution">
                                                    Post Dilution
                                                </mat-checkbox>
                                                <div class="action-icons">
                                                    <!-- <app-drop-down-arrow
                                                        *ngIf="!member.expandDetails && member.postDilutionChildren.length > 0"
                                                        [stroke]="'#50e3c2'" (click)="toggleDetails(member)"></app-drop-down-arrow>
                                                    <app-drop-down-arrow
                                                        *ngIf="member.expandDetails && member.postDilutionChildren.length > 0"
                                                        [pointUp]="true" [stroke]="'#50e3c2'"
                                                        (click)="toggleDetails(member)"></app-drop-down-arrow> -->
                                                    <app-close-x-icon
                                                        [ngStyle]="{'visibility': postDilutor.partner.name === 'Mibe Music' ? 'hidden' : 'visible'}"
                                                        [stroke]="'#FFFFFF'"
                                                        (click)="removeMemberFromGroup(postDilutor, element)"></app-close-x-icon>
                                                    <app-grab-icon
                                                        [ngStyle]="{'visibility': postDilutor.partner.name === 'Mibe Music' ? 'hidden' : 'visible'}"
                                                        cdkDragHandle [stroke]="'#FFFFFF'"></app-grab-icon>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- POST DILUTORS END -->
                            </div>
                        </div>
                    </div>
                </mat-cell>
            </ng-container>




            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"
                [ngClass]="{'group-row-expanded':styleExpandedDetailsRow(row), 'group-row': !styleExpandedDetailsRow(row)}"
                [attr.id]="row.group.id" class="partner-group-row"></mat-row>

            <!-- Expanded details row definition -->
            <mat-row *matRowDef="let row; columns: ['expandedDetails'];"
                [ngClass]="{'details-expanded':styleExpandedDetailsRow(row), 'details-hidden': !styleExpandedDetailsRow(row)}"></mat-row>

        </mat-table>
    </div>
</div>
<div class="loading-overlay" *ngIf="isImportingGroups">
    <app-loader color="#50e3c2"></app-loader>
</div>